import { IRectangle } from '@misc/blur/blur.service';

import { IStepOption } from '@misc/steps/steps.component';

export type Notification = IStepOption;

export interface IServerBlurFeedback {
  coordinates?: IRectangle[];
  id: number;
  blur_status: string;
  start_time: string;
}

export interface IResponseEmsNumberInfo {
  status?: 'success' | 'failure';
  generated_by: {
    id: number;
    first_name: string;
    last_name: string;
  } | null;
  generated_phone_no: string | null;
  generated_at: string | null;
  expires_at: string | null;
  ems_info: string | null;
  Error?: 'TIME_LIMIT_EXPIRE' | 'DUPLICATE_REQUEST';
}

export interface IEmsNumberInfo {
  status?: 'success' | 'failure';
  generatedBy: string | null;
  generatedPhoneNo: string | null;
  countryCode: string | null;
  generatedAt: string | null;
  expiresAt: string | null;
  emsInfo: string | null;
}

export enum NOTIFICATION_TYPE {
  GENERATED = 'generated',
  INITIATED = 'initiated',
  ERROR = 'error',
  DISCONNECTED = 'disconnected',
  COMPLETED = 'completed',
}

export interface INotificationUpdate {
  time: string,
  type: NOTIFICATION_TYPE,
  generatedBy?: string,
  emsInfo?: string,
  caller?: string,
}